export function month(date) {
  return new Date(date).getMonth() + 1;
}
